import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigationListItem } from "@sprout/list-navigation";
import { useMemo } from "react";
import { Draggable } from "react-beautiful-dnd";
import TopicPageSection from "../../TopicPage_Section";
const TopicPageViewsTopicListSectionWithListNavigation = (props)=>{
    const { section , isSortEnabled , isExpandable , index , __hideLater  } = props;
    const { id , nodeId  } = section;
    const navigationListItemProvided = useNavigationListItem(String(id), useMemo(()=>({
            index,
            object: section
        }), [
        index,
        section
    ]));
    return /*#__PURE__*/ _jsx(Draggable, {
        draggableId: String(section.id),
        index: index,
        isDragDisabled: !isSortEnabled || navigationListItemProvided.helpers.isMultiselectActive,
        children: (dragProvided, dragSnapshot)=>{
            return /*#__PURE__*/ _jsx(TopicPageSection, {
                topic: section,
                dragProvided: dragProvided,
                isSortEnabled: isSortEnabled,
                isDragging: dragSnapshot.isDragging,
                isGroupedOver: Boolean(dragSnapshot.combineTargetFor),
                navigationListItemProvided: navigationListItemProvided,
                expandable: isExpandable,
                __hideLater: __hideLater
            });
        }
    }, nodeId);
};
export default TopicPageViewsTopicListSectionWithListNavigation;
